import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiHostUrl, applicationContextRoot, SESSION_CHECK_INTERVAL, WAITING_TIME_SESSION } from '../../constants/constants';
import { useRefreshState } from './useRefreshState';
import API_Routes from '../../constants/api-routes';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { setNavigationData } from '../system/redux/reducers/NavigatedDataReducer';

// Define the context
const SessionTimeoutContext = createContext();

// Create a custom hook to use the session timeout context
export const useSessionTimeout = () => {
    return useContext(SessionTimeoutContext);
};

// Session Timeout Provider component
const SessionTimeoutProvider = () => {
    const navigate = useNavigate();
    const [isSessionValid, setIsSessionValid] = useState(true);
    const { csrfFormTagName, csrfToken } = useSelector((state) => state.csrf);
    const dispatch = useDispatch();

    console.log("INSIDE");
    const headers = {
        Accept: "*/*",
        "Content-Type": "application/x-www-form-urlencoded",
        "Access-Control-Allow-Credentials": true,
        "Access-control-Allow-Orogin": "*",
        redirect: "false",
    };

    var intervalId = null;

    const handleLogout = () => {
        try{
          console.log("Logout");
          //debugger;
          const formData = csrfFormTagName + "=" + csrfToken;
          async function logout() {
            const response = await axios
              .post(API_Routes.logout, formData, { withCredentials: true })
              .then((res) => {
                debugger;
                console.log(res.status);
                if (res.status === 200) {
                    dispatch(setNavigationData({}));
                  // handleNavigation();
                }
              });
          }
          logout();
        }catch(e){
          console.log(e);
        }
    };

    useEffect(() => {
        console.log("INSIDE SESSION TIMEOUT");
        const checkSession = async () => {

            try {
                console.log("Going to fetch login details");
                const response = axios
                    .get(API_Routes.loginInfo, { withCredentials: true }, headers)
                    .then((response) => {
                        //debugger;
                        console.log("Returned from fetching login details with response: " + JSON.stringify(response));
                        //console.log()
                        if (response.status === 200) {
                            if (response.data.isAuthenticated) {

                            }
                            else {
                                handleLogout();
                                setIsSessionValid(false);
                                window.location.reload();
                                //navigate(applicationContextRoot + "/login"); // Redirect to login page
                            }
                        }else {
                            handleLogout();
                            window.location.reload();
                            //navigate(applicationContextRoot + "/login"); // Redirect to login page
                        }
                    }).catch((error) => {
                        console.error("In catch block fetching login details with error: " + JSON.stringify(error));
                        console.log(error);
                    });
            } catch (error) {
                console.error("Exception fetching login details with error: " + JSON.stringify(error));
                console.error('Error checking session status:', error);
                handleLogout();
                setIsSessionValid(false);
                //navigate(applicationContextRoot + "/login");
                window.location.reload();
                // Redirect to login page on error
            }
        };

        //alert("Time: " + new Date() + ", intervalId: " + JSON.stringify(intervalId));

        if(intervalId){
            clearInterval(intervalId);
        }

        // Set an interval to check session status
        intervalId = setInterval(checkSession, SESSION_CHECK_INTERVAL + WAITING_TIME_SESSION);
        //alert("Started: " + new Date() + ", intervalId: " + JSON.stringify(intervalId));
        // Clean up the interval on component unmount
        //return () => clearInterval(intervalId);
    }, []);

    return { isSessionValid };
};

export default SessionTimeoutProvider;
